module.exports = __webpack_public_path__ + "static/media/domain.e5426d76.svg";